import AUMTargets from "../pages/AUMTargets";
import Departments from "../pages/Departments";
import EditAUMTarget from "../pages/EditAUMTarget";
import EditDepartment from "../pages/EditDepartment";
import EditRole from "../pages/EditRole";
import EditUser from "../pages/EditUser";
import NewAumTarget from "../pages/NewAUMTarget";
import NewOpportunity from "../pages/NewOpportunity";
import NewUser from "../pages/NewUser";
import Opportunities from "../pages/Opportunities";
import Roles from "../pages/Roles";
import ViewDepartment from "../pages/ViewDepartment";
import ViewOpportunity from "../pages/ViewOpportunity";
import ViewRole from "../pages/ViewRole";
import ViewUser from "../pages/ViewUser";

import EditEmailTemplate from "../pages/EditEmailTemplate";
import EmailTemplates from "../pages/EmailTemplates";
import TemplateCategories from "../pages/TemplateCategories";
import ViewEmailTemplate from "../pages/ViewEmailTemplate";

import EditProduct from "../pages/EditProduct";
import EditProductCategory from "../pages/EditProductCategory";
import NewProduct from "../pages/NewProduct";
import NewProductCategory from "../pages/NewProductCategory";
import ProductCategories from "../pages/ProductCategories";
import ProductStatements from "../pages/ProductStatements";
import Products from "../pages/Products";
import ViewProduct from "../pages/ViewProduct";
import ViewProductCategory from "../pages/ViewProductCategory";

import AuditLogs from "../pages/Audits";
import Users from "../pages/Users";
import Audit from "../pages/ViewAudit";

import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";

import NewEmailTemplate from "../pages/NewEmailTemplate";
import entitlements from "./entitlements";

import CustomerManagement from "../pages/CustomerManagement";
import ViewCustomer from "../pages/ViewCustomer";

import ClientManagement from "../pages/CompanyManagement";
import Entitlements from "../pages/Entitlements";
import ViewCompany from "../pages/ViewCompany";

import ViewEntitlement from "../pages/ViewEntitlement";

import NotificationRecords from "../pages/NotificationRecords";
import ViewNotificationRecord from "../pages/ViewNotificationRecord";

import NewTransferRequest from "../pages/NewTransferRequest";
import TransferRequests from "../pages/TransferRequests";
import ViewTransferRequest from "../pages/ViewTransferRequest";

// import ChangeRequests from "../pages/ChangeRequests";
import DownloadableTemplates from "../pages/DownloadableTemplates";
import Interactions from "../pages/Interactions";
import NewRedemptionRequest from "../pages/NewRedemptionRequest";
import AllOnlineTransactions from "../pages/OnlineTransactions";
import PreOpportunityInteractions from "../pages/PreOpportunityInteractions";
import RedemptionRequests from "../pages/RedemptionRequests";
import ViewExclusionList from "../pages/ViewExclusionList";
import ViewCustomerTransaction from "../pages/ViewOnlineTransaction";
import ViewRedemptionRequest from "../pages/ViewRedemptionRequest";
import { ViewReport } from "../pages/ViewReport";

import BulkUploads from "../pages/BulkUpload";
import CompanyActivityList from "../pages/CompanyActivityList";
import EditRedemptionRequest from "../pages/EditRedemptionRequest";
import EditTeam from "../pages/EditTeam";
import EditTransferRequest from "../pages/EditTransferRequest";
import ExclusionLists from "../pages/ExclusionLists";
import ExportDataRecords from "../pages/ExportDataRecords";
import Teams from "../pages/Teams";
import Ussd from "../pages/Ussd";
import ViewTeam from "../pages/ViewTeam";
import ArchivedCustomers from "../pages/ArchivedCustomers";
import ArchivedCompanies from "../pages/ArchivedCompanies";
import ViewArchivedCustomer from "../pages/ViewArchivedCustomer";
import ViewArchivedCompany from "../pages/ViewArchivedCompanies";
import Categories from "../pages/Categories";
import SubCategories from "../pages/Subcategories";
import ViewCategory from "../pages/ViewCategory";
import EditCategory from "../pages/EditCategory";
import EditSubCategory from "../pages/EditSubCategory";
import ViewSubCategory from "../pages/ViewSubCategory";
import EconomicIndicators from "../pages/EconomicIndicators";
import ViewEconomicIndicator from "../pages/ViewEconomicIndicator";
import EditEconomicIndicator from "../pages/EditEconomicIndicator";
import AssetAllocationItems from "../pages/AssetAllocationItems";
import ViewAssetAllocationItem from "../pages/ViewAssetAllocationItem";
import EditAssetAllocationItem from "../pages/EditAssetAllocationItem";
import ViewAssetAllocationRate from "../pages/ViewAssetAllocationRate";
import EditAssetAllocationRate from "../pages/EditAssetAllocationRate";
import ViewQuarter from "../pages/ViewQuarter";
import EditQuarter from "../pages/EditQuarter";
import AssetAllocationRates from "../pages/AssetAllocationRates";
import Quarters from "../pages/Quarters";
import NewAssetAllocation from "../pages/NewAssetAllocation";
import EditAssetAllocation from "../pages/EditAssetAllocation";
import NewSubcategory from "../pages/NewSubcategory";
import Trustees from "../pages/Trustees";
import ViewTrustee from "../pages/ViewTrustee";
import EditTrustee from "../pages/EditTrustee";
import QprReports from "../pages/QprReport";
import ViewTrusteeScheme from "../pages/ViewTrusteeScheme";
import EditTrusteeScheme from "../pages/EditTrusteeScheme";
import { NewLoanRequest } from "../pages/NewLoanRequest";
import LoanRequests from "../pages/LoanRequests";
import Providers from "../pages/Providers";
import ViewProvider from "../pages/ViewProvider";
import EditProvider from "../pages/EditProvider";
import ViewLoanRequest from "../pages/ViewLoanRequest";
import EditLoanRequest from "../pages/EditLoanRequest";
import { NewFixedIncomeRequest } from "../pages/NewFixedIncomeRequest";
import FixedIncomeRequests from "../pages/FixedIncomeRequests";
import EditFixedIncomeRequest from "../pages/EditFixedIncomeRequest";
import ViewFixedIncomeRequest from "../pages/ViewFixedIncomeRequest";
import Holidays from "../pages/Holidays";
import SalesPeople from "../pages/SalesPeople";
import ViewSalesPerson from "../pages/ViewSalesPerson";
import ViewFixedIncomeRedemption from "../pages/ViewFixedIncomeRedemption";
import FixedIncomePaymentInstructions from "../pages/FixedIncomePaymentInstructions";
import FixedIncomeRedemptions from "../pages/FixedIncomeRedemptions";
import ViewFixedIncomePaymentInstruction from "../pages/ViewFixedIncomePaymentInstruction";


export default [
  {
    path: "/",
    exact: true,
    entitlement: entitlements.Dashboard.view,
    title: "Dashboard",
    requiresAuth: true,
    component: Dashboard,
  },
  {
    path: "/login",
    exact: true,
    title: "Login",
    requiresAuth: false,
    component: Login,
  },
  {
    path: "/departments",
    exact: true,
    title: "Departments",
    entitlement: entitlements.Departments.list,
    requiresAuth: true,
    component: Departments,
  },
  {
    path: "/departments/:id",
    exact: true,
    title: "View Department",
    entitlement: entitlements.Departments.view,
    requiresAuth: true,
    component: ViewDepartment,
  },
  {
    path: "/departments/:id/edit",
    exact: true,
    title: "Edit Department",
    entitlement: entitlements.Departments.edit,
    requiresAuth: true,
    component: EditDepartment,
  },
  {
    path: "/roles",
    exact: true,
    title: "Roles",
    entitlement: entitlements.Roles.list,
    requiresAuth: true,
    component: Roles,
  },
  {
    path: "/roles/:id",
    exact: true,
    title: "View Role",
    entitlement: entitlements.Roles.view,
    requiresAuth: true,
    component: ViewRole,
  },
  {
    path: "/roles/:id/edit",
    exact: true,
    title: "Edit Role",
    entitlement: entitlements.Roles.edit,
    requiresAuth: true,
    component: EditRole,
  },
  {
    path: "/users",
    exact: true,
    title: "Users",
    entitlement: entitlements.Users.list,
    requiresAuth: true,
    component: Users,
  },
  {
    path: "/users/new",
    exact: true,
    title: "New User",
    entitlement: entitlements.Users.create,
    requiresAuth: true,
    component: NewUser,
  },
  {
    path: "/users/:id",
    exact: true,
    title: "View User",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: ViewUser,
  },
  {
    path: "/users/:id/edit",
    exact: true,
    title: "Edit User",
    entitlement: entitlements.Users.edit,
    requiresAuth: true,
    component: EditUser,
  },
  {
    path: "/sales-people",
    exact: true,
    title: "Sales People",
    entitlement: entitlements.Users.list,
    requiresAuth: true,
    component: SalesPeople,
  },
  {
    path: "/sales-people/:id",
    exact: true,
    title: "View Sales Person",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: ViewSalesPerson,
  },
  {
    path: "/trustees",
    exact: true,
    title: "Trustees",
    entitlement: entitlements.Trustees.list,
    requiresAuth: true,
    component: Trustees,
  },
  {
    path: "/trustees/:id",
    exact: true,
    title: "View Trustee",
    entitlement: entitlements.Trustees.view,
    requiresAuth: true,
    component: ViewTrustee,
  },
  {
    path: "/trustees/:id/edit",
    exact: true,
    title: "Edit Trustee",
    entitlement: entitlements.Trustees.edit,
    requiresAuth: true,
    component: EditTrustee,
  },
  {
    path: "/trustees/:id/schemes",
    exact: true,
    title: "View Trustee",
    entitlement: entitlements.Trustees.view,
    requiresAuth: true,
    component: ViewTrustee,
  },
  {
    path: "/trustees/:id/schemes/:schemeId",
    exact: true,
    title: "View Trustee Scheme",
    entitlement: entitlements.TrusteeSchemes.view,
    requiresAuth: true,
    component: ViewTrusteeScheme,
  },
  {
    path: "/trustees/:id/schemes/:schemeId/edit",
    exact: true,
    title: "Edit Trustee Scheme",
    entitlement: entitlements.TrusteeSchemes.edit,
    requiresAuth: true,
    component: EditTrusteeScheme,
  },
  {
    path: "/audits",
    exact: true,
    title: "Audits",
    entitlement: entitlements.Audits.list,
    requiresAuth: true,
    component: AuditLogs,
  },
  {
    path: "/audits/:id",
    exact: true,
    title: "View Audit",
    entitlement: entitlements.Audits.view,
    requiresAuth: true,
    component: Audit,
  },
  {
    path: "/business-development",
    exact: true,
    title: "Opportunities",
    entitlement: entitlements.BusinessDevelopment.list,
    requiresAuth: true,
    component: Opportunities,
  },
  {
    path: "/business-development/opportunity",
    exact: true,
    title: "Opportunities",
    entitlement: entitlements.BusinessDevelopment.list,
    requiresAuth: true,
    component: Opportunities,
  },
  {
    path: "/business-development/new-opportunity",
    exact: true,
    title: "New Opportunity",
    entitlement: entitlements.BusinessDevelopment.create,
    requiresAuth: true,
    component: NewOpportunity,
  },
  {
    path: "/business-development/opportunity/:id",
    exact: true,
    title: "View Opportunity",
    entitlement: entitlements.BusinessDevelopment.view,
    requiresAuth: true,
    component: ViewOpportunity,
  },
  {
    path: "/aum-targets",
    exact: true,
    title: "AUM Targets",
    entitlement: entitlements.AUMTargets.list,
    requiresAuth: true,
    component: AUMTargets,
  },
  {
    path: "/aum-targets/new",
    exact: true,
    title: "New AUM-Target",
    entitlement: entitlements.AUMTargets.create,
    requiresAuth: true,
    component: NewAumTarget,
  },
  {
    path: "/aum-targets/:id/edit",
    exact: true,
    title: "Update AUM-Target",
    entitlement: entitlements.AUMTargets.edit,
    requiresAuth: true,
    component: EditAUMTarget,
  },
  {
    path: "/communication-templates",
    exact: true,
    title: "All templates",
    entitlement: entitlements.Templates.list,
    requiresAuth: true,
    component: EmailTemplates,
  },
  {
    path: "/communication-templates/new",
    exact: true,
    title: "Create template",
    entitlement: entitlements.Templates.create,
    requiresAuth: true,
    component: NewEmailTemplate,
  },
  {
    path: "/communication-templates/:id",
    exact: true,
    title: "View template",
    entitlement: entitlements.Templates.view,
    requiresAuth: true,
    component: ViewEmailTemplate,
  },
  {
    path: "/communication-templates/:id/edit",
    exact: true,
    title: "Edit template",
    entitlement: entitlements.Templates.edit,
    requiresAuth: true,
    component: EditEmailTemplate,
  },
  {
    path: "/template-categories",
    exact: true,
    title: "Template Categories",
    entitlement: entitlements.Templates.list,
    requiresAuth: true,
    component: TemplateCategories,
  },
  {
    path: "/products",
    exact: true,
    title: "Products",
    entitlement: entitlements.Products.list,
    requiresAuth: true,
    component: Products,
  },
  {
    path: "/products/new",
    exact: true,
    title: "New Product",
    entitlement: entitlements.Products.create,
    requiresAuth: true,
    component: NewProduct,
  },
  {
    path: "/products/:id",
    exact: true,
    title: "View Product",
    entitlement: entitlements.Products.view,
    requiresAuth: true,
    component: ViewProduct,
  },
  {
    path: "/products/:id/subproducts",
    exact: true,
    title: "View Product",
    entitlement: entitlements.Products.view,
    requiresAuth: true,
    component: ViewProduct,
  },
  {
    path: "/products/:id/subproducts/new",
    exact: true,
    title: "New Subproduct",
    entitlement: entitlements.Products.create,
    requiresAuth: true,
    component: NewProduct,
  },
  {
    path: "/products/:id/subproducts/:subproductId",
    exact: true,
    title: "View Subproduct",
    entitlement: entitlements.Products.view,
    requiresAuth: true,
    component: ViewProduct,
  },
  {
    path: "/products/:id/subproducts/:subproductId/edit",
    exact: true,
    title: "Edit Subproduct",
    entitlement: entitlements.Products.edit,
    requiresAuth: true,
    component: EditProduct,
  },
  {
    path: "/products/:id/edit",
    exact: true,
    title: "Edit Product",
    entitlement: entitlements.Products.edit,
    requiresAuth: true,
    component: EditProduct,
  },
  {
    path: "/product-categories",
    exact: true,
    title: "Product Categories",
    entitlement: entitlements.ProductCategories.list,
    requiresAuth: true,
    component: ProductCategories,
  },
  {
    path: "/product-categories/new",
    exact: true,
    title: "New Product Category",
    entitlement: entitlements.ProductCategories.create,
    requiresAuth: true,
    component: NewProductCategory,
  },
  {
    path: "/product-categories/:id",
    exact: true,
    title: "View Product Category",
    entitlement: entitlements.ProductCategories.view,
    requiresAuth: true,
    component: ViewProductCategory,
  },
  {
    path: "/product-categories/:id/edit",
    exact: true,
    title: "Edit Product Category",
    entitlement: entitlements.ProductCategories.edit,
    requiresAuth: true,
    component: EditProductCategory,
  },
  {
    path: "/product-statements",
    exact: true,
    title: "Product Statements",
    entitlement: entitlements.ProductStatements.view,
    requiresAuth: true,
    component: ProductStatements,
  },
  {
    path: "/customers",
    exact: true,
    title: "Manage Customers",
    entitlement: entitlements.Customers.list,
    requiresAuth: true,
    component: CustomerManagement,
  },
  {
    path: "/customers/:id",
    exact: true,
    title: "View Customer",
    entitlement: entitlements.Customers.view,
    requiresAuth: true,
    component: ViewCustomer,
  },

  {
    path: "/companies",
    exact: true,
    title: "Manage Companies",
    entitlement: entitlements.Companies.list,
    requiresAuth: true,
    component: ClientManagement,
  },

  {
    path: "/companies/:id",
    exact: true,
    title: "View Company",
    entitlement: entitlements.Companies.view,
    requiresAuth: true,
    component: ViewCompany,
  },
  {
    path: "/entitlements",
    exact: true,
    title: "Entitlements",
    entitlement: entitlements.Entitlements.list,
    requiresAuth: true,
    component: Entitlements,
  },

  {
    path: "/entitlements/:id",
    exact: true,
    title: "View Entitlement",
    entitlement: entitlements.Entitlements.view,
    requiresAuth: true,
    component: ViewEntitlement,
  },
  {
    path: "/notification-records",
    exact: true,
    title: "Notification Records",
    entitlement: entitlements.NotifierRecords.list,
    requiresAuth: true,
    component: NotificationRecords,
  },
  {
    path: "/notification-records/:id",
    exact: true,
    title: "View Notification Record",
    entitlement: entitlements.NotifierRecords.view,
    requiresAuth: true,
    component: ViewNotificationRecord,
  },
  {
    path: "/transfer-requests",
    exact: true,
    title: "Transfer Requests",
    entitlement: entitlements.TransferRequests.list,
    requiresAuth: true,
    component: TransferRequests,
  },
  {
    path: "/transfer-requests/new",
    exact: true,
    title: "New Transfer Request",
    entitlement: entitlements.TransferRequests.create,
    requiresAuth: true,
    component: NewTransferRequest,
  },

  {
    path: "/transfer-requests/:id",
    exact: true,
    title: "View Transfer Request",
    entitlement: entitlements.TransferRequests.view,
    requiresAuth: true,
    component: ViewTransferRequest,
  },
  {
    path: "/transfer-requests/:id/edit",
    exact: true,
    title: "Edit Transfer Request",
    entitlement: entitlements.TransferRequests.edit,
    requiresAuth: true,
    component: EditTransferRequest,
  },
  {
    path: "/redemption-requests",
    exact: true,
    title: "Redemption Requests",
    entitlement: entitlements.RedemptionRequests.list,
    requiresAuth: true,
    component: RedemptionRequests,
  },
  {
    path: "/redemption-requests/new",
    exact: true,
    title: "New Redemption Request",
    entitlement: entitlements.RedemptionRequests.create,
    requiresAuth: true,
    component: NewRedemptionRequest,
  },
  // {
  //   path: "/change-requests",
  //   exact: true,
  //   title: "Change Requests",
  //   entitlement: entitlements.ChangeRequests.list,
  //   requiresAuth: true,
  //   component: ChangeRequests,
  // },
  {
    path: "/providers/:id",
    exact: true,
    title: "View Provider",
    entitlement: entitlements.LoanProviders.view,
    requiresAuth: true,
    component: ViewProvider,
  },
  {
    path: "/providers/:id/edit",
    exact: true,
    title: "Edit Provider",
    entitlement: entitlements.LoanProviders.edit,
    requiresAuth: true,
    component: EditProvider,
  },
  {
    path: "/providers",
    exact: true,
    title: "Providers",
    entitlement: entitlements.LoanProviders.list,
    requiresAuth: true,
    component: Providers,
  },
  {
    path: "/loan-requests",
    exact: true,
    title: "Loan Requests",
    entitlement: entitlements.LoanRequests.list,
    requiresAuth: true,
    component: LoanRequests,
  },
  {
    path: "/loan-requests/new",
    exact: true,
    title: "New Loan Request",
    entitlement: entitlements.LoanRequests.create,
    requiresAuth: true,
    component: NewLoanRequest,
  },
  {
    path: "/loan-requests/:id",
    exact: true,
    title: "View Loan Request",
    entitlement: entitlements.LoanRequests.view,
    requiresAuth: true,
    component: ViewLoanRequest,
  },
  {
    path: "/loan-requests/:id/edit",
    exact: true,
    title: "Edit Loan Request",
    entitlement: entitlements.LoanRequests.edit,
    requiresAuth: true,
    component: EditLoanRequest,
  },
  {
    path: "/fixed-income-requests",
    exact: true,
    title: "Fixed Income Requests",
    entitlement: entitlements.FixedIncomeRequests.list,
    requiresAuth: true,
    component: FixedIncomeRequests,
  },
  {
    path: "/fixed-income-requests/new",
    exact: true,
    title: "New Fixed Income Request",
    entitlement: entitlements.FixedIncomeRequests.create,
    requiresAuth: true,
    component: NewFixedIncomeRequest,
  },
  {
    path: "/fixed-income-requests/:id",
    exact: true,
    title: "View Fixed Income Request",
    entitlement: entitlements.FixedIncomeRequests.view,
    requiresAuth: true,
    component: ViewFixedIncomeRequest,
  },
  {
    path: "/fixed-income-requests/:id/edit",
    exact: true,
    title: "Edit Fixed Income Request",
    entitlement: entitlements.FixedIncomeRequests.edit,
    requiresAuth: true,
    component: EditFixedIncomeRequest,
  },
  {
    path: "/fixed-income-redemptions/:id",
    exact: true,
    title: "View Fixed Income Redemption",
    entitlement: entitlements.FixedIncomeRequests.view,
    requiresAuth: true,
    component: ViewFixedIncomeRedemption,
  },
  {
    path: "/fixed-income-redemptions",
    exact: true,
    title: "Fixed Income Redemptions",
    entitlement: entitlements.FixedIncomeRequests.view,
    requiresAuth: true,
    component: FixedIncomeRedemptions,
  },
  {
    path: "/fixed-income-payment-instructions/:id",
    exact: true,
    title: "View Fixed Income Payment Instruction",
    entitlement: entitlements.FixedIncomeRequests.view,
    requiresAuth: true,
    component: ViewFixedIncomePaymentInstruction,
  },
  {
    path: "/fixed-income-payment-instructions",
    exact: true,
    title: "Fixed Income Payment Instructions",
    entitlement: entitlements.FixedIncomeRequests.view,
    requiresAuth: true,
    component: FixedIncomePaymentInstructions,
  },
  {
    path: "/pre-op-interactions",
    exact: true,
    title: "Pre Opportunity Interactions",
    entitlement: entitlements.BusinessDevelopment.interactions.list,
    requiresAuth: true,
    component: PreOpportunityInteractions,
  },
  {
    path: "/downloadable-templates",
    exact: true,
    title: "Downloadable Templates",
    entitlement: entitlements.Templates.list,
    requiresAuth: true,
    component: DownloadableTemplates,
  },
  {
    path: "/reports",
    exact: true,
    title: "Reports",
    entitlement: entitlements.Dashboard.view,
    requiresAuth: true,
    component: ViewReport,
  },
  {
    path: "/redemption-requests/:id",
    exact: true,
    title: "View Redemption Request",
    entitlement: entitlements.RedemptionRequests.view,
    requiresAuth: true,
    component: ViewRedemptionRequest,
  },
  {
    path: "/redemption-requests/:id/edit",
    exact: true,
    title: "Edit Redemption Request",
    entitlement: entitlements.RedemptionRequests.edit,
    requiresAuth: true,
    component: EditRedemptionRequest,
  },
  {
    path: "/teams",
    exact: true,
    title: "Teams",
    entitlement: entitlements.Companies.teams.list,
    requiresAuth: true,
    component: Teams,
  },
  {
    path: "/teams/:id",
    exact: true,
    title: "View Team",
    entitlement: entitlements.Companies.teams.view,
    requiresAuth: true,
    component: ViewTeam,
  },
  {
    path: "/teams/:id/edit",
    exact: true,
    title: "Edit Team",
    entitlement: entitlements.Companies.teams.edit,
    requiresAuth: true,
    component: EditTeam,
  },
  {
    path: "/interactions",
    exact: true,
    title: "Interactions",
    entitlement: entitlements.BusinessDevelopment.interactions.list,
    requiresAuth: true,
    component: Interactions,
  },
  {
    path: "/exclusion-lists",
    exact: true,
    title: "Exclusion Lists",
    entitlement: entitlements.ExclusionLists.list,
    requiresAuth: true,
    component: ExclusionLists,
  },
  {
    path: "/exclusion-lists/:id",
    exact: true,
    title: "View Exclusion List",
    entitlement: entitlements.ExclusionLists.view,
    requiresAuth: true,
    component: ViewExclusionList,
  },
  {
    path: "/online-transactions",
    exact: true,
    title: "Online Transactions",
    entitlement: entitlements.OnlineTransactions.list,
    requiresAuth: true,
    component: AllOnlineTransactions,
  },
  {
    path: "/online-transactions/:id",
    exact: true,
    title: "View Online Transaction",
    entitlement: entitlements.OnlineTransactions.view,
    requiresAuth: true,
    component: ViewCustomerTransaction,
  },
  {
    path: "/company-activities",
    exact: true,
    title: "Company Activities",
    entitlement: entitlements.CompanyActivities.list,
    requiresAuth: true,
    component: CompanyActivityList,
  },
  {
    path: "/bulk-uploads",
    exact: true,
    title: "Bulk Uploads",
    entitlement: entitlements.BulkUploads.view,
    requiresAuth: true,
    component: BulkUploads,
  },
  {
    path: "/ussd",
    exact: true,
    title: "USSD",
    entitlement: entitlements.Ussd.list,
    requiresAuth: true,
    component: Ussd,
  },
  {
    path: "/exported-data",
    exact: true,
    title: "Exported Data Records",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: ExportDataRecords,
  },
  {
    path: "/archived-customers",
    exact: true,
    title: "Archived Customers",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: ArchivedCustomers,
  },
  {
    path: "/archived-companies",
    exact: true,
    title: "Archived Companies",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: ArchivedCompanies,
  },
  {
    path: "/archived-customers/:id",
    exact: true,
    title: "View Archived Customer",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: ViewArchivedCustomer,
  },
  {
    path: "/archived-companies/:id",
    exact: true,
    title: "View Archived Company",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: ViewArchivedCompany,
  },
  {
    path: "/categories",
    exact: true,
    title: "Categories",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: Categories,
  },
  {
    path: "/subCategories",
    exact: true,
    title: "Subcategories",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: SubCategories,
  },
  {
    path: "/subCategories/new",
    exact: true,
    title: "New Subcategory",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: NewSubcategory,
  },
  {
    path: "/categories/:id",
    exact: true,
    title: "View Category",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: ViewCategory,
  },
  {
    path: "/categories/:id/edit",
    exact: true,
    title: "Edit Category",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: EditCategory,
  },
  {
    path: "/subCategories/:id/edit",
    exact: true,
    title: "Edit Subcategory",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: EditSubCategory,
  },
  {
    path: "/subCategories/:id",
    exact: true,
    title: "View Subcategory",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: ViewSubCategory,
  },
  {
    path: "/economic-indicators",
    exact: true,
    title: "Economic Indicators",
    entitlement: entitlements.EconomicIndicators.list,
    requiresAuth: true,
    component: EconomicIndicators,
  },
  {
    path: "/economic-indicators/:id",
    exact: true,
    title: "View Economic Indicator",
    entitlement: entitlements.EconomicIndicators.view,
    requiresAuth: true,
    component: ViewEconomicIndicator,
  },
  {
    path: "/economic-indicators/:id/edit",
    exact: true,
    title: "Edit Economic Indicator",
    entitlement: entitlements.EconomicIndicators.edit,
    requiresAuth: true,
    component: EditEconomicIndicator,
  },
  {
    path: "/asset-allocation-items",
    exact: true,
    title: "Asset Allocation Items",
    entitlement: entitlements.EconomicIndicators.list,
    requiresAuth: true,
    component: AssetAllocationItems,
  },
  {
    path: "/asset-allocation-items/:id",
    exact: true,
    title: "View Asset Allocation Item",
    entitlement: entitlements.EconomicIndicators.view,
    requiresAuth: true,
    component: ViewAssetAllocationItem,
  },
  {
    path: "/asset-allocation-items/:id/edit",
    exact: true,
    title: "Edit Asset Allocation Item",
    entitlement: entitlements.EconomicIndicators.edit,
    requiresAuth: true,
    component: EditAssetAllocationItem,
  },
  {
    path: "/asset-allocation-rates",
    exact: true,
    title: "Asset Allocation Rates",
    entitlement: entitlements.EconomicIndicators.list,
    requiresAuth: true,
    component: AssetAllocationRates,
  },
  {
    path: "/asset-allocation-rates/:id",
    exact: true,
    title: "View Asset Allocation Rate",
    entitlement: entitlements.EconomicIndicators.view,
    requiresAuth: true,
    component: ViewAssetAllocationRate,
  },
  {
    path: "/asset-allocation-rates/:id/edit",
    exact: true,
    title: "Edit Asset Allocation Rate",
    entitlement: entitlements.EconomicIndicators.edit,
    requiresAuth: true,
    component: EditAssetAllocationRate,
  },
  {
    path: "/quarters",
    exact: true,
    title: "Quarters",
    entitlement: entitlements.EconomicIndicators.list,
    requiresAuth: true,
    component: Quarters,
  },
  {
    path: "/quarters/:id",
    exact: true,
    title: "View Quarter",
    entitlement: entitlements.EconomicIndicators.view,
    requiresAuth: true,
    component: ViewQuarter,
  },
  {
    path: "/quarters/:id/edit",
    exact: true,
    title: "Edit Quarter",
    entitlement: entitlements.EconomicIndicators.edit,
    requiresAuth: true,
    component: EditQuarter,
  },
  {
    path: "/quarters/:id/asset-allocations/:id",
    exact: true,
    title: "Edit Asset Allocation",
    entitlement: entitlements.EconomicIndicators.edit,
    requiresAuth: true,
    component: EditAssetAllocation,
  },
  {
    path: "/quarters/:id/asset-allocations",
    exact: true,
    title: "View Quarter",
    entitlement: entitlements.EconomicIndicators.view,
    requiresAuth: true,
    component: ViewQuarter,
  },
  {
    path: "/quarters/:id/new-asset-allocation",
    exact: true,
    title: "New Asset Allocation",
    entitlement: entitlements.EconomicIndicators.create,
    requiresAuth: true,
    component: NewAssetAllocation,
  },
  {
    path: "/qpr-reports",
    exact: true,
    title: "QPR Reports",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: QprReports,
  },
  {
    path: "/holidays",
    exact: true,
    title: "Holidays",
    entitlement: entitlements.Users.view,
    requiresAuth: true,
    component: Holidays,
  },
];
